export default "__VITE_ASSET__7GTndGtI__"